export const HOME_PAGE_TAB_OPTIONS = Object.freeze({
  Overview: 'overview',
  DataDashboard: 'dashboard',
});

export type HomePageTabOption = typeof HOME_PAGE_TAB_OPTIONS[keyof typeof HOME_PAGE_TAB_OPTIONS];